import React from "react";
import Image from "../../components/image";
import { completeMsiRedirectLogin } from "../../utils/msi_auth";

class MSIRedirectCallback extends React.Component {
    componentDidMount() {
        if (window.opener && window.opener !== window) {
            window.close();
            return;
        }

        this.finalizeLogin();
    }

    redirectToLogin(message) {
        const errorMessage = message || "Microsoft login failed";
        localStorage.setItem("error_message", errorMessage);
        window.setTimeout(() => {
            window.location.replace("/login");
        }, 1500);
    }

    async finalizeLogin() {
        try {
            const hasQueryResponse = window.location.search && window.location.search.length > 0;
            const hasHashResponse = window.location.hash && window.location.hash.length > 0;
            if (!hasQueryResponse && !hasHashResponse) {
                throw new Error("Microsoft login response was not received.");
            }

            const loginResult = await completeMsiRedirectLogin();
            if (!loginResult || !loginResult.redirectUrl) {
                throw new Error("Microsoft login could not be completed.");
            }

            window.location.replace(loginResult.redirectUrl);
        } catch (error) {
            this.redirectToLogin(error && error.message ? error.message : "Microsoft login failed");
        }
    }

    render() {
        return (
            <div className="fullpage-loader">
                <div><Image src="logo" /></div>
                <div className="qd-spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                </div>
            </div>
        );
    }
}

export default MSIRedirectCallback;
